export default [
  {
    meta: 'JavaScript',
    title: 'Understanding how closures work ',
    path: 'https://w#',
  },


]
